<ng-container *transloco="let t">
<div class="border border-dashed border-gray-300 rounded px-7 py-3 mb-6">
  <div class="d-flex flex-stack mb-3">
    <div class="me-3">
      <a href="javascript:void(0)" (click)="onViewFileClicked(document)"
        class="text-primary text-hover-primary fw-bold text-decoration-underline">{{document.fileName}}</a>
    </div>

    <div class="d-flex align-items-center m-0">
      <span class="text-gray-500 fs-8 me-3">{{ document.insertedByName || '' }}{{ document.insertedByName && document.dateInserted ? ' at ' : '' }}{{ document.dateInserted ? (document.dateInserted | date : "MM/dd/yyyy h:mm a") : '' }}{{ !document.insertedByName && !document.dateInserted ? '--' : '' }}</span>
      <label class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body" (click)="onDownloadFileClicked(document)">
        <i class="bi bi-cloud-download fs-2"></i>
      </label>
    </div>
  </div>

  <div class="d-flex flex-stack" *ngIf="document.note">
    <span class="text-gray-400 fw-bold">{{ t('portal.tasks.notes') }}:
      <span class="text-gray-800 fw-bold">{{ document.note }}</span>
    </span>
  </div>
</div>
</ng-container>
